module.exports = __webpack_public_path__ + "static/media/3_Profil_osteraker.7c03f2b9.jpg";